module.exports = {
  template: require('./appointments-show.pug')()
  controller: require('./appointments-show.ctrl')
  bindings:
    appointment: '<'
}
